// extracted by mini-css-extract-plugin
module.exports = {"createArrearsTextArea":"styles_createArrearsTextArea__33JqM","textAreaTitle":"styles_textAreaTitle__2C5xP"};